import { Directive, HostListener, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[decimalLimit]'
})
export class DecimalLimitDirective {

  @Input('decimalLimit') decimalLimit = 2; // default = 2 decimals

  private specialKeys: string[] = [
    'Backspace', 'Tab', 'End', 'Home',
    'ArrowLeft', 'ArrowRight', 'Delete', 'Enter'
  ];

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {

    // Allow Ctrl/Cmd shortcuts
    if ((event.ctrlKey || event.metaKey) &&
        ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase())) {
      return;
    }

    // Allow navigation keys
    if (this.specialKeys.includes(event.key)) {
      return;
    }

    const input = this.el.nativeElement;
    const current = input.value;

    // Handle dot
    if (event.key === '.') {
      if (current.includes('.')) {
        event.preventDefault();
      }
      return;
    }

    // Block non-numeric
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Remove invalid characters
    value = value.replace(/[^0-9.]/g, '');

    // Allow only one dot
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }

    // Limit decimal places dynamically
    if (parts.length === 2 && parts[1].length > this.decimalLimit) {
      value = parts[0] + '.' + parts[1].substring(0, this.decimalLimit);
    }

    if (input.value !== value) {
      input.value = value;
      input.dispatchEvent(new Event('input'));
    }
  }
}
